import { Suspense, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  fetchAllDropdownProjects,
  fetchAllDropdownSource,
  fetchAllDropdownUser,
  fetchCompanyData,
  fetchLoginUserDetail,
  fetchUserPermissions,
  fetchUserProfile,
} from "store/actions";
import { useIdleTimeout } from "hooks";
import { admin, routeToHideFromUserRole } from "utils/constants";
import { parseData } from "utils/helpers";
import { LoadingSpinner } from "components/ui";
import { userDetailState, userSettingState } from "store/selectors";
import { AppHeader, ProtectedRoute, SideNav } from "components";
import { useAppDispatch, useAppSelector } from "store/hooks";
import styles from "./styles.module.css";

export function AppLayout() {
  console.log(new Date());

  const { isIdle } = useIdleTimeout();
  const userData = parseData(localStorage.getItem("user-detail"));

  const { userDetail, isAuthenticated, isAdmin, isManager } =
    useAppSelector(userDetailState);
  const { isDarkMode } = useAppSelector(userSettingState);
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const userId = userData?.userId;

  useEffect(() => {
    if (userData?.token && !userDetail) {
      // userId
      dispatch(fetchLoginUserDetail({ userId }));
    }

    const timeout = setTimeout(() => {
      userId && dispatch(fetchUserProfile({ userId }));
      userId && dispatch(fetchCompanyData({ page: 1 }));
      userId && dispatch(fetchUserPermissions({ userId }));

      userId && dispatch(fetchAllDropdownProjects({ page: 1 }));
      userId && dispatch(fetchAllDropdownSource({ page: 1 }));
      userId && dispatch(fetchAllDropdownUser({ page: 1 }));
    }, 300);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (!!!userData?.token && !!!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated]);

  if (!userDetail) {
    return <p>Loading...</p>;
  }

  const isProtectedRoute: boolean = routeToHideFromUserRole?.includes(pathname);

  return (
    <main className={styles.layoutContainer}>
      <SideNav />
      <div
        className={`${styles.routeContent} ${
          isDarkMode ? styles.routeContentDark : ""
        }`}
      >
        <AppHeader />
        <Suspense fallback={<LoadingSpinner />}>
          {isProtectedRoute ? (
            <ProtectedRoute
              element={<Outlet />}
              isAllowed={isAdmin || isManager}
            />
          ) : (
            <Outlet />
          )}
        </Suspense>
      </div>
    </main>
  );
}
